import React, { useEffect, useRef } from "react";
import { LenguageTabla } from "../../Comunes/LenguajeTabla/LenguajeTabla";
import moment from "moment";
import $ from "jquery";
import { Notificar } from "../../Comunes/Notificador";

function OperacionesCambioDeudor({
  operaciones,
  actualizarOperaciones = null,
  permiteSeleccionar = false,
  permiteEliminar = false,
}) {
  const tableRef = useRef();

  useEffect(() => {
    const botonesTabla = permiteSeleccionar ? ["selectAll", "selectNone"] : [];
    const posicionDom = permiteSeleccionar
      ? '<"mb-3"B><"float-left"l><"text-right"f>rt<"float-left"i><"text-right"p>'
      : '<"float-left"l><"text-right"f>rt<"float-left"i><"text-right"p>';

    const tabla = $(tableRef.current).DataTable({
      language: LenguageTabla,
      pageLength: 10,
      processing: true,
      destroy: true,
      data: operaciones,
      select: permiteSeleccionar && {
        style: "multi",
        selector: "td:first-child",
      },
      dom: posicionDom,
      buttons: botonesTabla,
      columns: [
        {
          title: "Selecionar",
          data: null,
        },
        {
          title: "Operación",
          data: "operacion",
        },
        {
          title: "Periodo Inicial",
          data: "periodoInicio",
          render: function (row) {
            return row !== null ? moment(row).format("DD/MM/YYYY") : "";
          },
        },
        {
          title: "Periodo Final",
          data: "periodoFin",
          render: function (row) {
            return row !== null ? moment(row).format("DD/MM/YYYY") : "";
          },
        },
        {
          title: "Excluir de Solicitud",
          data: null,
        },
      ],
      columnDefs: [
        {
          targets: 0,
          defaultContent: "",
          className: "select-checkbox",
          searchable: false,
          orderable: false,
          visible: permiteSeleccionar,
        },
        {
          targets: 4,
          defaultContent:
            "<button class='btn btn-danger btn-sm js-eliminar'><i class='fa fa-trash'></i></button>",
          searchable: false,
          orderable: false,
          visible: permiteEliminar,
        },
      ],
    });

    tabla.off("click");

    tabla.on("select deselect", function (e) {
      actualizarOperaciones(tabla.rows({ selected: true }).data().toArray());
    });

    tabla.on("click", ".js-eliminar", function () {
      if (tabla.rows().data().count() === 1) {
        Notificar(
          "error",
          "No se puede eliminar. La solicitud debe tener al menos una operación."
        );
        return;
      }

      tabla.row($(this).parents("tr")).remove().draw();
      actualizarOperaciones(tabla.rows().data().toArray());
    });
  }, [operaciones, actualizarOperaciones, permiteSeleccionar, permiteEliminar]);

  return (
    <div className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">Operaciones</h6>
      </div>
      <div className="card-body">
        <table
          className="table table-striped table-hover w-auto display"
          ref={tableRef}
        />
      </div>
    </div>
  );
}

export default OperacionesCambioDeudor;
